export { default as Carousel, type CarouselProps } from './Carousel';
